"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _invariant = _interopRequireDefault(require("invariant"));
var returnState = function returnState(state) {
  return state;
};
var reducerMap = function reducerMap(map, initialState) {
  if (map === void 0) {
    map = {};
  }
  if (initialState === void 0) {
    initialState = {};
  }
  return function (state, action) {
    if (state === void 0) {
      state = initialState;
    }
    (0, _invariant.default)(typeof action === 'object' && action.type != null, 'Invalid action, `type` is required.');
    var reducer = typeof map[action.type] === 'function' ? map[action.type] : returnState;
    return reducer(state, action);
  };
};
var _default = exports.default = reducerMap;